var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-sm navbar-btn me-1 mb-1 c-tool-btn",class:_vm.active ? 'text-primary' : '',attrs:{"title":"Favoriten"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_c('i',{class:_vm.css}),_c('span',{staticClass:"c-tool-btn-label"},[_vm._v("Favoriten")])])
}
var staticRenderFns = []

export { render, staticRenderFns }